import { cn } from "@/lib/utils"
import { AppointmentAttachment, AttachmentItem } from "@/modules/patients/components/attachments/attachment-item"
import { usePreviewDocumentDialogStore } from "@/stores/usePreviewDocumentDialogStore"

interface AttachmentListProps extends React.ComponentPropsWithoutRef<"div"> {
  appointmentId?: string
  mediaFiles: AppointmentAttachment[]
  displayNumber?: number
  enableAddAttachment?: boolean
  onAddAttachment?: () => void
}

const AttachmentList = ({
  mediaFiles,
  displayNumber = 5,
  className,
  appointmentId,
  ...attachmentProps
}: AttachmentListProps) => {
  const displayFiles = mediaFiles.slice(0, displayNumber)
  const hasRemaining = mediaFiles.length > displayNumber
  const setIndex = usePreviewDocumentDialogStore((state) => state.setIndex)
  const setMediaFiles = usePreviewDocumentDialogStore((state) => state.setMediaFiles)
  const setPreviewDocumentAppointmentId = usePreviewDocumentDialogStore(
    (state) => state.setPreviewDocumentAppointmentId,
  )

  return (
    <div className={cn("flex flex-wrap gap-2", className)} {...attachmentProps}>
      {displayFiles.map((mediaFile, idx) => (
        <AttachmentItem
          onClick={() => {
            setIndex(idx)
            setMediaFiles(mediaFiles)
            if (appointmentId) {
              setPreviewDocumentAppointmentId(appointmentId)
            }
          }}
          mediaFile={mediaFile}
          remains={hasRemaining && idx === displayFiles.length - 1 ? mediaFiles.length - displayNumber : 0}
          key={mediaFile.id}
        />
      ))}
    </div>
  )
}

export { AttachmentList }
